exports = module.exports = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5c35de11] .el-input .el-input__inner[name=readonly]{padding:0}[data-v-5c35de11] .el-tag{margin-right:5px;margin-bottom:5px}.flex[data-v-5c35de11]{display:-webkit-box;display:-ms-flexbox;display:flex}.justify-center[data-v-5c35de11]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.w-10[data-v-5c35de11]{width:2.5rem}.h-10[data-v-5c35de11]{height:2.5rem}.rounded[data-v-5c35de11]{border-radius:5px}.el-icon-error[data-v-5c35de11]{margin-left:10px}", ""]);

// exports
